export default __webpack_public_path__ + "static/22-high-tech-83ea981263a98738b0536fbd8efaa06c.png";